"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveItemPriceOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var RemoveItemPriceOutputWidget = /** @class */ (function (_super) {
    __extends(RemoveItemPriceOutputWidget, _super);
    function RemoveItemPriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refundRequired = _this.props.interaction.factors.returnPremium > 0;
        return _this;
    }
    RemoveItemPriceOutputWidget.prototype.render = function () {
        var itemToProcess = JSON.parse(window.sessionStorage.getItem("itemToProcess"));
        if (this.refundRequired) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center", children: [(0, jsx_runtime_1.jsx)("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2", children: (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium) }), (0, jsx_runtime_1.jsxs)("div", { children: ["will be refunded as a result of removing your ", (0, jsx_runtime_1.jsxs)("b", { className: "font-weight-semi-bold", children: [" ", itemToProcess.description] })] })] }));
        }
        else {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center", children: ["There is no refund due as a result of removing your ", (0, jsx_runtime_1.jsxs)("b", { className: "font-weight-semi-bold", children: [" ", itemToProcess.description] })] }));
        }
    };
    return RemoveItemPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.RemoveItemPriceOutputWidget = RemoveItemPriceOutputWidget;
//# sourceMappingURL=RemoveItemPriceOutputWidget.js.map